import React from "react";
import Button from "../components/SurveyButton";
import { questionTypeLabels } from "../domain/survey.constants";

const QuestionNavigator = ({ questions, errors, selectedQuestionId, readOnly, onSelect, onMove, onRemove, onAdd }) => (
  <>
    <div className="survey-builder-navigator survey-builder-horizontal-navigator">
      {questions.map((question, index) => {
        const questionErrors = (errors.questions && errors.questions[index]) || {};
        return <div className={`survey-builder-nav-item ${selectedQuestionId === question.id ? "active" : ""} ${Object.keys(questionErrors).length ? "survey-builder-nav-item-has-error" : ""}`} key={question.id}>
          <button type="button" className="survey-builder-nav-select" onClick={() => onSelect(question.id)}>
            <span className="survey-builder-nav-number">{index + 1}</span><span className="survey-builder-nav-copy"><strong>{question.question || `Question ${index + 1}`}</strong><small>{questionTypeLabels[question.type] || question.type}</small></span>
          </button>
          {!readOnly && <span className="survey-builder-nav-actions"><button type="button" title="Move up" disabled={index === 0} onClick={() => onMove(index, index - 1)}>↑</button><button type="button" title="Move down" disabled={index === questions.length - 1} onClick={() => onMove(index, index + 1)}>↓</button><button type="button" title="Remove" className="remove" onClick={() => onRemove(index)}>×</button></span>}
        </div>;
      })}
      {!questions.length && <div className="survey-builder-empty">No questions added.</div>}
    </div>
    {errors.questionsRoot && <div className="survey-engine-validation-banner survey-builder-root-error">{errors.questionsRoot}</div>}
    {!readOnly && <div className="survey-builder-add-questions"><strong>Add question</strong><div>{Object.keys(questionTypeLabels).map((type) => <Button key={type} bsSize="small" icon="fa-plus" onClick={() => onAdd(type)}>{questionTypeLabels[type]}</Button>)}</div></div>}
  </>
);

export default QuestionNavigator;
